// @flow
/* eslint-disable import/prefer-default-export */

import fetch from 'axios';
import _ from 'lodash';
import store from 'client/redux/store';
import { LOGOUT } from 'client/containers/Login/redux';
import { getToken } from 'client/utils/user';

class Client {
  constructor() {
    ['get', 'post', 'put', 'patch', 'del', 'head'].forEach((method : any) => {
      (this : any)[method] = Client.Request(method);
    });
  }

  static Request(method : string) : any {
    return async (url : any, data : any) => {
      const { requestURL, request } = await Client.decorateRequest({ method, url, data });
      return new Promise((resolve : any, reject : any) => {
        fetch(requestURL, request)
          .then((response : any) => Client.checkStatus(response, resolve, reject))
          .catch((error : any) => Client.checkStatus(error, resolve, reject))
          .catch(reject);
      });
    };
  }

  static async parseJSON(res : any) : any {
    if (!res) {
      return {};
    }
    const data = await res.json();
    const { status, ok } = res;
    return { data, ok, status };
  }

  static checkStatus(response : any, resolve : any, reject : any) : any {
    if (_.get(response, ['headers', 'www-authenticate']) === 'jwt') {
      store.dispatch({ type: LOGOUT, data: { skip: true } });
    }
    if (!_.get(response, ['data'])) {
      return reject(response);
    }
    const { status, data } = response;
    if (status >= 200 && status < 300) {
      return resolve(data);
    } else if (status >= 300 && status < 400) {
      throw new Error('>= 300 && status < 400');
    } else if (status === 400) {
      throw new Error('Probably is a validation error');
    } else if (status === 403 || status === 401) {
      return resolve(data);
    } else if (status === 404) {
      throw new Error('Not Found');
    } else if (status >= 500) {
      throw new Error('Server error');
    }
    return null;
  }

  static async decorateRequest({ method, url, data } : any) : any {
    const defaults = {
      body: data,
      method: method.toUpperCase(),
      headers: {},
      mode: 'cors',
    };
    const isFullURL = url.includes('http');
    let requestURL;
    if (isFullURL) {
      const [path, query] = url.replace('https://www.aparat.com/api/fa/v1/', '').split('?');
      requestURL = process.env.NODE_ENV === 'development'
        ? `/${process.env.API_ROOT}/${path}${query ? `?${query}` : ''}`
        : url;
    } else {
      const [path, query] = url.split('?');
      const baseUrl = process.env.NODE_ENV === 'development'
        ? `/${process.env.API_ROOT}/${path}`
        : `${process.env.API_PROTOCOL}://${process.env.API_SUBDOMAIN}.${process.env.API_BASE}/${process.env.API_ROOT}/${path}`;

      requestURL = query
        ? `${baseUrl}/devicetype/tv_web?${query}`
        : `${baseUrl}/devicetype/tv_web`;
    }
    const headers = await Client.getHeaderDataDecoration();
    if (!defaults.body) {
      delete defaults.body;
    }
    return {
      request: {
        ...defaults,
        headers,
      },
      requestURL,
    };
  }

  static async getHeaderDataDecoration() : any {
    const headers = {
      'Content-Type': 'application/json; charset=UTF-8',
      jsonType: 'simple',
      UserAgent: JSON.stringify({
        an: 'Aparat',
        os: _.get(window, ['webOS', 'platform', 'tv']) ? 'tv_lg' : 'tv',
      }),
      Authorization: `Bearer ${getToken() || ''}`,
      deviceType: 'tv_web',
    };
    Object.keys(headers)
      .forEach((item : string) => {
        if (!headers[item]) {
          delete headers[item];
        }
      });
    return headers;
  }
}

export default new Client();
